import { render } from "./UiPropBoxShadow.vue?vue&type=template&id=18538164&scoped=true"
import script from "./UiPropBoxShadow.vue?vue&type=script&lang=js"
export * from "./UiPropBoxShadow.vue?vue&type=script&lang=js"

import "./UiPropBoxShadow.vue?vue&type=style&index=0&id=18538164&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18538164"]])

export default __exports__